<div class="single-video innerpage_sec">
  <div class="elevation_left"></div>
  <div class="photo_overlay_center"></div>
  <div class="photo_overlay_right"></div>
  <!-- banner_flower -->
  <!-- <div class="banner_flower sec-padding">
    <img src="../../../../../assets/images/banner-elevation.png" alt="img">
  </div> -->
  <div class="wrapper">
    <div class="custom_heading">
      <h2 class="title">
        Galleries and <span> Videos</span>
      </h2>
    </div>
    <div class="gall-vid">
      <mat-button-toggle-group [formControl]="mediaType">
      <mat-button-toggle value="IMAGE">Images</mat-button-toggle>
      <mat-button-toggle value="VIDEO">Videos</mat-button-toggle>
    </mat-button-toggle-group>
    </div>

    <div *ngIf="mediaType.value === 'IMAGE'">
       <ng-container *ngFor="let single of albums; let i = index">
      <img [src]="single.src" (click)="open(i)"/>
       </ng-container>
    </div>

   <div *ngIf="mediaType.value === 'VIDEO'">
     
    <ng-container *ngFor="let singleVideo of villageVideoItems; let i = index">
      <video [src]="singleVideo.video.url" controls ></video>
    </ng-container>
  </div>


  </div>
</div>

<!-- <section class="innerpage_bottom_sec">
  <div class="initiatives_top"></div>
</section> -->
